function baseClamp(e,o,a){return e==e&&(void 0!==a&&(e=e<=a?e:a),void 0!==o&&(e=o<=e?e:o)),e}module.exports=baseClamp;